import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import Times from '@v2/context/Times/page';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';

interface BatchDetailsNCFileTimesProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const BatchDetailsNCFileTimesComponent: FC<BatchDetailsNCFileTimesProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  ncFileData,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Times
        withoutPaddingHorizontal
        ncFileId={ncFileData?.data?.ncFileId}
        style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
      />
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFileTimesComponent);

export { BatchDetailsNCFileTimes };
